import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import PieChartComponent from '../../../../library/SimpleControls/PieChartControl';
import useRecruiterDashboard from './useRecruiterDashboard';

const RecruiterWorkingIndustry = () => {
    const { state } = useContext(SmartContext);
    const { getRecruiterWorkingIndustryData } = useRecruiterDashboard();

    useEffect(() => {
        getRecruiterWorkingIndustryData();
    }, []);

    if (isEmpty(state.data?.reportData?.recruiterWorkingIndustry)) 
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <PieChartComponent data={state.data.reportData.recruiterWorkingIndustry} />
        </>
    );
};

export default RecruiterWorkingIndustry;
